import { Box, styled } from '@mui/material';

import { FROZEN_DROP_PREVIEW_Z_INDEX } from '../../frozenDrop.constants';

export const FrozenCard = styled(Box)({
  position: 'fixed',
  // Sit just under the LoadingOverlay so the card shows through the
  // translucent overlay during the load state.
  zIndex: FROZEN_DROP_PREVIEW_Z_INDEX,
  pointerEvents: 'none',
  // Lift the frozen card off the list so it reads as the pending drop and
  // doesn't blend with the surrounding cards. drop-shadow follows the card
  // silhouette (incl. rounded corners); no colour change.
  filter: 'drop-shadow(0 3px 10px rgba(0, 0, 0, 0.35))'
});
